﻿$.fn.dxCtrlWizardDomaineDedie = function custom_dxCtrlWizardDomaineDedie(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlwizarddomainededie dx-ctrl");
        this.createInstance(new cdxCtrlWizardDomaineDedie(this, option));
    }
    return this;
}

window.cdxCtrlWizardDomaineDedie = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dxWizard = null;
    function mConstruit() {
        container.empty();

        if (typeof option.domaine == 'undefined') option.domaine = ""

        var wizardItemDoc = new cWizardItem()
        wizardItemDoc.allowScroll = false
        wizardItemDoc.itemTemplate = function (itemElement, wizard) {
            var $EleDoc = $("<iframe style='height:100%;width:100%;border-radius:3px;box-sizing:border-box;border:none;' class='dx-theme-background-color' src='" + parametre.url_cognoss + "//0/19/Utiliser_un_domaine_dedie/bc'/>").appendTo(itemElement)
            var $DivBt = $("<div style='text-align:right'>").appendTo(itemElement)
            mRempliBt($DivBt)
            $EleDoc.css("height", "calc(100% - " + $DivBt.innerHeight() + "px)")
        }
        wizardItemDoc.getNextItem = function () {
            return wizardItemDomaine
        }
        wizardItemDoc.getPreviousItem = function () { return null; }
        wizardItemDoc.isOkForNext = function () { return true }

        var dxTxtDomaine = null
        var wizardItemDomaine = new cWizardItem()
        wizardItemDomaine.allowScroll = false
        wizardItemDomaine.itemTemplate = function (itemElement, wizard) {
            var $DivContainer = $("<div style='height:100%;'/>").appendTo(itemElement)
            $("<div style='font-size:120%;text-align:center;'>Saisissez le domaine que vous voulez utiliser pour vos emailing</div>").appendTo($DivContainer)
            $("<div style='font-size:100%;text-align:center;font-style:italic;'>Choisissez un domaine que vous possédez et pour lequel vous avez accés à son interface de configuration</div>").appendTo($DivContainer)
            dxTxtDomaine = $("<div style='margin:20px 20%;'/>").appendTo($DivContainer).dxCtrlTextBox({
                label: "Nom de domaine",
                labelMode: 'floating',
                value: option.domaine,
                onKeyDown: function (e) { $DivResultatSaisieDomaine.text("") },
                onInput: function (e) {
                    e.event.target.value = e.event.target.value.toLowerCase();
                },
                onFocusIn: function (e) {
                    option.domaine = ""
                },
                onValueChanged: function (e) {
                    option.domaine = ""
                    if (e.value == null || e.value == "") {
                        $DivResultatSaisieDomaine.css("color", "red")
                        $DivResultatSaisieDomaine.text("⚠ Veuillez saisir un nom de domaine.")
                        dxTxtDomaine.focus()
                        return
                    }
                    var regex = /^(?!-)(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,}$/;
                    if (!regex.test(e.value)) {
                        $DivResultatSaisieDomaine.css("color", "red")
                        $DivResultatSaisieDomaine.text("⚠ Veuillez saisir un domaine valide.")
                        dxTxtDomaine.focus()
                        return
                    }
                    option.bddCtrl.mAjaxCall({ command: "verifydomaineexist", domaine: e.value }, function (data) {
                        if (data.domaine_deja_saisie_autre_client == "1") {
                            $DivResultatSaisieDomaine.css("color", "red")
                            $DivResultatSaisieDomaine.text("⚠ Ce domaine est déjà défini sur un autre environnement.")
                            dxTxtDomaine.focus()
                        } else if (data.domaine_deja_saisie == "1") {
                            $DivResultatSaisieDomaine.css("color", "orange")
                            $DivResultatSaisieDomaine.text("⚠ Ce domaine a déjà été configuré en tant que domaine dédié sur votre compte.<br/>Rendez vous sur votre compte client dans le menu utilisateur pour le configurer ou le supprimer.")
                            var $A = $("<a href='javascript:void(0)'>Afficher mes domaines dédiés</a>").appendTo($DivResultatSaisieDomaine)
                            $A.on("click", function (e) {
                                $("<div/>").appendTo("body").dxCtrlPopupContentCompteClientForUtilisateur({
                                    bddCtrl: option.bddCtrl,
                                    selectedItemKeys: [5]
                                })
                                dxWizard.hide()
                                if (typeof option.onClose != 'undefined') option.onClose()
                            })
                            dxTxtDomaine.focus()
                        } else if (data.domaine_exist == "0") {
                            $DivResultatSaisieDomaine.css("color", "red")
                            $DivResultatSaisieDomaine.text("⚠ Ce domaine n'existe pas sur le web. Veuillez vérifiez votre saisie.")
                            dxTxtDomaine.focus()
                        } else {
                            $DivResultatSaisieDomaine.css("color", "green")
                            $DivResultatSaisieDomaine.text("✌ Ce domaine existe sur internet et vous pouvez l'utiliser en domaine dédié.")
                            option.domaine = e.value
                        }
                    })
                }
            }).dxCtrlTextBox("instance")
            var $DivResultatSaisieDomaine = $("<div style='color:red;text-align:center;'></div>").appendTo($DivContainer)

            dxTxtDomaine.focus()

            var $DivBt = $("<div style='text-align:right'>").appendTo(itemElement)
            mRempliBt($DivBt)
            $DivContainer.css("height", "calc(100% - " + $DivBt.innerHeight() + "px)")
        }
        wizardItemDomaine.getNextItem = function () {
            return wizardItemDns
        }
        wizardItemDomaine.getPreviousItem = function () { return wizardItemDoc; }
        wizardItemDomaine.isOkForNext = function () {
            if (option.domaine.length > 0) { return true }
            else { dxTxtDomaine.option("onValueChanged")({ value: dxTxtDomaine.option("value") }) }
        }

        //var dxDomaineEmail = null
        //var adresseEmail = null
        //var wizardItemEmail = new cWizardItem()
        //wizardItemEmail.allowScroll = false
        //wizardItemEmail.itemTemplate = function (itemElement, wizard) {
        //    dxDomaineEmail = $("<div/>").appendTo(itemElement).dxCtrlDomaineDedieEmail({
        //        bddCtrl: option.bddCtrl,
        //        adresse_email: adresseEmail,
        //        domaine: domaine,
        //        onValueChanged(adr) { adresseEmail = adr }
        //    }).dxCtrlDomaineDedieEmail("instance")
        //}
        //wizardItemEmail.getNextItem = function () {
        //    return wizardItemDns
        //}
        //wizardItemEmail.getPreviousItem = function () { return wizardItemDomaine; }
        //wizardItemEmail.isOkForNext = function () { return !dxDomaineEmail.isInSaisieCode }

        var dxDns = null
        var wizardItemDns = new cWizardItem()
        wizardItemDns.allowScroll = true
        wizardItemDns.itemTemplate = function (itemElement, wizard) {
            dxDns = $("<div style='height:100%;min-height:200px;'/>").appendTo(itemElement).dxCtrlDomaineDedieDns({
                bddCtrl: option.bddCtrl,
                domaine: option.domaine
            }).dxCtrlDomaineDedieDns("instance")

            var $DivBt = $("<div style='text-align:right'>").appendTo(itemElement)
            mRempliBt($DivBt)
            dxDns.element().css("height", "calc(100% - " + $DivBt.innerHeight() + "px)")
        }
        wizardItemDns.getNextItem = function () {
            return wizardItemFin
        }
        wizardItemDns.getPreviousItem = function () { return wizardItemDomaine; }
        wizardItemDns.isOkForNext = function () {
            if (!dxDns.isOk()) {
                mNotify("Vos DNS sur <b>" + option.domaine + "</b> ne sont pas correcte", "error", 6000)
                return false
            }
            return true
        }

        var wizardItemFin = new cWizardItem()
        wizardItemFin.allowScroll = false
        wizardItemFin.itemTemplate = function (itemElement, wizard) {
            var $DivContainer = $("<div style='height:100%;'/>").appendTo(itemElement)
            $("<div style='font-size:120%;text-align:center;'>Bravo, votre domaine <b>" + option.domaine + "</b> est correctement configuré.</div>").appendTo($DivContainer)
            $("<div style='padding-top:20px;text-align:center;'>Cliquer sur <b>Ajouter le domaine dédié</b> pour enregistrer votre celui-ci dans " + parametre.nom + ".</div>").appendTo($DivContainer)

            $("<div style='display:inline-block;'/>").appendTo($("<div style='padding-top:20px;text-align:center;'></div>").appendTo($DivContainer)).dxCtrlButton({
                text: "Ajouter le domaine dédié dans " + parametre.nom,
                onClick: function (e) {
                    mCreateDomaine()
                }
            })

            var $DivBt = $("<div style='text-align:right'>").appendTo(itemElement)
            mRempliBt($DivBt)
            $DivContainer.css("height", "calc(100% - " + $DivBt.innerHeight() + "px)")
        }
        wizardItemFin.getNextItem = function () {
            return null
        }
        wizardItemFin.getPreviousItem = function () { return wizardItemDns; }
        wizardItemFin.isOkForNext = function () {

        }

        dxWizard = container.appendTo("body").dxCtrlWizard({
            bddCtrl: option.bddCtrl,
            dataSource: [wizardItemDoc, wizardItemDomaine, wizardItemDns, wizardItemFin],
            title: ((typeof option.title == 'undefined') ? "Ajouter votre domaine dédié" : option.title),
            onClickClose: function (target) {
                dxWizard.hide()
                if (typeof option.onClose != 'undefined') option.onClose()
            },
            onValidate: function () {
                mCreateDomaine()
            }
        }).dxCtrlWizard("instance")
    }

    function mCreateDomaine() {
        jaugeDemarrage.mShow()
        option.bddCtrl.mAjaxCall({
            command: "enregistrerdomainededie",
            domaine: option.domaine
        }, function (data) {
            dxWizard.hide()
            if (typeof option.onClose != 'undefined') option.onClose()
            jaugeDemarrage.mHide()
        })
    }

    function mRempliBt(contentElement) {
        $("<div style='display:inline-block'/>").appendTo(contentElement).dxCtrlButton({
            text: "Abandonner",
            hint: "Abandonner la configuration de votre domaine dédié pour y revenir plus tard",
            onClick: function () { dxWizard.hide(); }
        })
    }

    this.element = function () { return container }

    mConstruit();
}